import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    categoryLink: {
      padding: '9px 14px',
      boxSizing: 'border-box',
      borderRadius: '999em',
      fontWeight: 'bold',
      fontSize: 14,
      textDecoration: 'none',
      color: colorsPalette.white,
      lineHeight: 1,
      backgroundColor: colorsPalette.violetAnalyticsCard,
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 16,
        padding: '9px 19px',
      },
    },
  }),
);

export default useStyles;
